import { render, staticRenderFns } from "./AcademySectionRegister.vue?vue&type=template&id=67f2fea3&"
import script from "./AcademySectionRegister.vue?vue&type=script&lang=js&"
export * from "./AcademySectionRegister.vue?vue&type=script&lang=js&"
import style0 from "./AcademySectionRegister.vue?vue&type=style&index=0&id=67f2fea3&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GDPRConsent: require('/home/smiley/3df/components/GDPRConsent.vue').default})
